import { ActionReducerMap } from '@ngrx/store';
import { dataReducer, EmailsSharedState } from './data/reducer';

export interface State {
  data: EmailsSharedState;
}

export const reducers: ActionReducerMap<State> = {
  data: dataReducer
};
